import React from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useNavigate, useLocation } from 'react-router-dom';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatNull, formatDate, isWithinLastHalfHour, formatDateTime } from '../../Utils/GlobalUtils';

import Modal from '../Modal';
import ModalRight from '../ModalRight';
import FileViewerModal from '../FileViewerModal';
import EditAccounting from './Components/EditAccounting';
import ReportIntervalPanel from './Components/ReportIntervalPanel';

import Loading from '../Loading';
import LoadingLines from '../LoadingLines';
import WarningPanel from '../WarningPanel';

import ButtonWithConfirmation from '../ButtonWithConfirmation';

import IconContainer from '../IconContainer';
import { ReactComponent as CheckIcon } from '../../icons/check.svg';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

const Accounting = ({ caseId }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { openTimeModal } = useTimeModal();

    const [reports, setReports] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [reloadBoxes, setReloadBoxes] = React.useState(1);
    const [loading, setLoading] = React.useState(true);

    const [formInfo, setFormInfo] = React.useState({});

    const [isAdmin, setIsAdmin] = React.useState(false);
    
    React.useEffect(() => {
        const token = localStorage.getItem('token');
    
        try {
            const decodedToken = jwtDecode(token);
            if (decodedToken.role==='АппаратСРО') {
                setIsAdmin(true);
            } else {
                setIsAdmin(false);
            }
        } catch (error) {
            console.error('Ошибка при декодировании токена: ', error);
        }

        axios.get(`/api/get-full-info-case?id=${caseId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then((response) => {
            setFormInfo(response.data);
        })
        .catch((error) => {
            // if (error.response?.data.action == 'logout') window.location.href = '/auth/logout';
            setFormInfo([]);
            openTimeModal('У вас недостаточно прав на просмотр содержимого', 'error');
            window.location.href = '/'
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
    }, [])

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-case-reports?case_id=${caseId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then((response) => {
            setWarning('');
            setReports(response.data);
        })
        .catch((error) => {
            console.error(error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, caseId]);

    const [statusLoading, setStatusLoading] = React.useState('');
    const [showDecisionButtons, setShowDecisionButtons] = React.useState(null);

    const approveReport = (id, approvedStatus) => {
        const token = localStorage.getItem('token');

        setStatusLoading(id);

        axios.put(`/api/change-report-status`, {
            id: id,
            approved: approvedStatus,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            openTimeModal('Статус изменен', 'success');
            setReload(true);
        }).catch((error) => {
            console.error(error);
            openTimeModal('Статус не изменен', 'error');
        }).finally(() => {
            setStatusLoading(null);
        })
    }

    const handleDelete = (id) => {
        axios.delete(`/api/delete-report`, {
            data: { id: id }
        })
        .then(() => {
            setReload(true);
            openTimeModal('Отчёт успешно удален', 'success');
        })
        .catch((error) => {
            openTimeModal('Ошибка при удалении отчёта', 'error');
        })
    };

    const [isEditModal, setIsEditModal] = React.useState(false);
    const [currentId, setCurrentId] = React.useState('');
    const [currentAction, setCurrentAction] = React.useState('');
    
    const openSuperModal = (id, action) => {
        setCurrentId(id);
        setCurrentAction(action);
        setIsEditModal(true);
    };

    const [isFileViewerModal, setIsFileViewerModal] = React.useState(false);
    const [currentFileId, setCurrentFileId] = React.useState('');


    return (
        <>
        <ModalRight isOpen={isFileViewerModal} closeModal={() => setIsFileViewerModal(false)} >
            <FileViewerModal closeModal={() => setIsFileViewerModal(false)} id={currentFileId} />
        </ModalRight>
        <Modal isOpen={isEditModal} closeModal={() => setIsEditModal(false)} >
            <EditAccounting closeModal={() => setIsEditModal(false)} id={currentId} action={currentAction} caseId={caseId} onSuccess={() => {setReload(true); setReloadBoxes(reloadBoxes+1)}} />
        </Modal>

        {loading ? <Loading /> 
        : (formInfo.status=='Заявка' || formInfo.status=='Управляющий не назначен') ? <p className='description'>Отчётность недоступна при статусе карточки "Заявка" и "Управляющий не назначен"</p>
        :
        <>
        {(formInfo.status=='В работе') && 
        <>

        <ReportIntervalPanel caseId={caseId} reloadBoxes={reloadBoxes} />

        <div style={{height: '20px'}}></div>
        </>}
        
        <div className='tableContainer'>
            <div className='tableHeaderWrapper'>
                <div className='tableStatus'>
                    <button type='button' className='secondaryButton' onClick={() => {openSuperModal('', 'add')}}>
                        <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                        <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                        </svg>
                        Добавить отчёт
                    </button>
                    <a className='lastUpdateWrapper'>
                        {loading ? 
                            <Loading type='inline' /> 
                        : 
                            <IconContainer Icon={ReloadIcon} onClick={() => {setReload(true); setLoading(true)}} size = '14' color = 'black' className = '' />
                        }
                    </a>
                </div>
                <div className='tableHeader' style={{ gridTemplateColumns: '10fr 25fr 29fr 10fr 13fr 7fr 6fr' }}>
                    <div>Дата собрания (комитета)</div>
                    <div>Повестка (комментарий)</div>
                    <div>Отчёт</div>
                    <div>Дата загрузки</div>
                    <div>Статус</div>
                    <div></div>
                </div>
            </div>
            {(reports.length==0 && loading) ? <LoadingLines /> 
            : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => { setReload(true); setLoading(true) }} />
            : reports.map((report) => (
                <div 
                    className='tableDoubleRow' 
                    key={report.id} 
                >
                    <div 
                        className='row'
                        style={{ gridTemplateColumns: '10fr 25fr 29fr 10fr 13fr 7fr 6fr' }}
                    >
                        <div>{formatDate(report.date)}</div>
                        <div>{formatNull(report.comment)}</div>
                        <div>{formatNull(report.report)}</div>
                        <div>{formatNull(formatDateTime(report.created_at))}</div>
                        <div className={`${report.status==='Отклонено' ? 'redCell' : undefined}`}>
                            <p>{formatNull(report.status)} {report.approverDetails && `(${report.approverDetails?.lastname} ${report.approverDetails?.firstname} ${report.approverDetails?.surname} ${report.approverDetails?.email})`}</p>
                        </div>
                        <div className='horizontalCell'>
                        {isAdmin && (
                            statusLoading === report.id ? (
                                <Loading type="inline" />
                            ) : (
                                <>
                                    {!report.approver_id ? (
                                        <div className="horizontalCell">
                                            <IconContainer Icon={XIcon} label='Отклонить отчёт' onClick={() => approveReport(report.id, false)} size='16' color='red' />
                                            <IconContainer Icon={CheckIcon} label='Одобрить отчёт' onClick={() => approveReport(report.id, true)} size='16' color='green'/>
                                        </div>
                                    ) : (
                                        showDecisionButtons !== report.id ? (
                                            <button
                                                onClick={() => setShowDecisionButtons(report.id)}
                                                className="tableButton"
                                            >
                                                Изменить решение
                                            </button>
                                        ) : (
                                            <div className="horizontalCell">
                                                <IconContainer Icon={XIcon} label='Отклонить отчёт' onClick={() => approveReport(report.id, false)} size='16' color='red' />
                                                <IconContainer Icon={CheckIcon} label='Одобрить отчёт' onClick={() => approveReport(report.id, true)} size='16' color='green'/>
                                            </div>
                                        )
                                    )}
                                </>
                            )
                        )}
                        </div>
                        <div style={{alignItems: 'end'}}>
                            {(isAdmin || isWithinLastHalfHour(report.created_at)) && 
                            <ButtonWithConfirmation
                                entryFunc={() => {handleDelete(report.id)}} 
                                Icon={TrashIcon} 
                                IconSize={17}
                                buttonName='Удалить' 
                                color='red' 
                            />}
                        </div>
                    </div>
                    <div 
                        className='horizontalRow'
                        style={{ gridTemplateColumns: '1fr' }}
                    >
                        {report.files?.length===0 ?
                        <p className='description'>Файлы не прикреплены. Вероятно, произошла ошибка</p>
                        : report.files?.map((fileInfo) => (
                            <button type='button' className='tableButton' onClick={() => {setCurrentFileId(fileInfo.id); setIsFileViewerModal(true)}}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="file"><path d="M20,8.94a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19l-.09,0L13.06,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V9S20,9,20,8.94ZM14,5.41,16.59,8H14ZM18,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4h5V9a1,1,0,0,0,1,1h5Z"></path></svg>
                                {fileInfo.name}
                            </button>
                        ))}
                    </div>
                </div>
            ))}
        </div>
        </>}
    </>
  )
}

export default Accounting;